import React from 'react'
import DashboardMaster from '../../../../dashboard/DashboardMaster'
import PriceContent from './PriceContent'

const Prices = () => {
    return (
        <DashboardMaster>
            <PriceContent />
        </DashboardMaster>
    )
}

export default Prices
